import { render, staticRenderFns } from "./reportCover2.vue?vue&type=template&id=f208e240&"
import script from "./reportCover2.vue?vue&type=script&lang=js&"
export * from "./reportCover2.vue?vue&type=script&lang=js&"
import style0 from "./reportCover2.vue?vue&type=style&index=0&id=f208e240&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports